import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "react-loader-spinner";
import { Link } from "react-router-dom";
import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export default function LookRegistration() {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [fields, setFields] = useState({});
  const [data, setResponse] = useState({});
  const [returnMessage, setReturnMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const [category, setCategory] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");

  const closed = false;

  const handleChange = (event) => {
    const name = event.target.name;
    if (name === "category") setCategory(event.target.value);

    setFields({ ...fields, [name]: event.target.value });
  };

  const handleSubmit = (event) => {
    setSubmitLoading(true);
    setReturnMessage({});
    if (phoneNumber && isPossiblePhoneNumber(phoneNumber)) {
      event.preventDefault();

      setReturnMessage({});

      axios
        .post("/v1/api/look", fields, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            setResponse(response.data);
            setSubmit(true);
          }
          setSubmitLoading(false);
        })
        .catch(function (error) {
          if (error.response) {
            const response_error = error.response.data;
            setReturnMessage(response_error);
            console.log(response_error);
            setSubmitLoading(false);
          }
        });
    } else {
      event.preventDefault();
      setIsPhoneValid(false);
      setSubmitLoading(false);
    }
  };

  const selectCountry = (val) => {
    setCountry(val);
    setFields({ ...fields, country_of_residence: val });
  };

  const selectRegion = (val) => {
    setRegion(val);
    setFields({ ...fields, state_region: val });
  };

  const selectPhoneNumber = (phone) => {
    setPhoneNumber(phone);
    setFields({ ...fields, phone_number: phone });
  };

  // Function to render appropriate level options based on category
  const renderLevelOptions = () => {
    if (category === "Student (Primary)") {
      return (
        <select
          className="form-control"
          name="year_level_part"
          onChange={handleChange}
          required
        >
          <option value="">Class</option>
          <option value="Primary 1">Primary 1</option>
          <option value="Primary 2">Primary 2</option>
          <option value="Primary 3">Primary 3</option>
          <option value="Primary 4">Primary 4</option>
          <option value="Primary 5">Primary 5</option>
          <option value="Primary 6">Primary 6</option>
        </select>
      );
    } else if (category === "Student (Secondary)") {
      return (
        <select
          className="form-control"
          name="year_level_part"
          onChange={handleChange}
          required
        >
          <option value="">Class</option>
          <option value="JSS 1">JSS 1</option>
          <option value="JSS 2">JSS 2</option>
          <option value="JSS 3">JSS 3</option>
          <option value="SS 1">SS 1</option>
          <option value="SS 2">SS 2</option>
          <option value="SS 3">SS 3</option>
        </select>
      );
    } else {
      return (
        <select
          className="form-control"
          name="year_level_part"
          onChange={handleChange}
          required
        >
          <option value="">Year/Level/Part</option>
          <option value="100 level">100 level</option>
          <option value="200 level">200 level</option>
          <option value="300 level">300 level</option>
          <option value="400 level">400 level</option>
          <option value="500 level">500 level</option>
          <option value="600 level">600 level</option>
        </select>
      );
    }
  };

  return (
    <div>
      <Header />
      <Banner page="LOOK Conference" pageName="Registration" />

      <section className="contact_area section_gap whole-wrap">
        <div className="container">
          <div className="page-cover text-center">
            <div className="row justify-content-center">
              <div className="col-md-6  align-self-center">
                <div className="donation_form registration">
                  {submit && (
                    <div>
                      <h3>LOOK Form Submitted Successfully</h3>
                      <p>
                        Hi <strong>{data.name}</strong> , Your registration is
                        successful. We willl send you a confirmation email to{" "}
                        {data.email} on how to participate in the conference .
                        <br />
                        <br />

                        To get timely update, kindly join the LOOK 2026 WhatsApp group via the link below.

                        https://chat.whatsapp.com/BlWOU3akYQC7IWVhPSamPU <br/>

                        


                        You can check out what we have been up to on our Blog
                      </p>

                      <Link to="/blog" className="btn_hover btn_hover_two">
                        Visit Blog
                      </Link>
                      <br />

                      <Link to="/" className="genric-btn link">
                        Back to Home Page
                      </Link>
                    </div>
                  )}

                  {!submit && closed && (
                    <div>
                      <h3>LOOK Registration closed</h3>
                      <p>
                        Registration for LOOK 2026 is now closed
                        <br />
                        <br />
                        You can check out what we have been up to on our Blog
                      </p>

                      <Link to="/blog" className="btn_hover btn_hover_two">
                        Visit Blog
                      </Link>
                      <br />

                      <Link to="/" className="genric-btn link">
                        Back to Home Page
                      </Link>
                    </div>
                  )}

                  {!closed && !submit && (
                    <form onSubmit={handleSubmit} method="post">
                      <h3><Link to="/look"> LOOK </Link> International Mission Conference 2026</h3>

                      <h5>"NO TURNING BACK" - Luke 9:62</h5>

                      <p>"No one who puts a hand to the plough and looks back is fit for the Kingdom of God"</p>

                      <p style={{ textAlign: "justify" }}>
                      Believers are called to unwavering commitment in Christian missions. Just as a farmer must look forward to ploughing straight, 
                      Christians must stay focused on Christ without returning to old ways or comfort.<br />
                        <br />

                        Mission requires perseverance, courage, and lifelong devotion. In a world filled with distractions and moral confusion, 
                        mission-minded Christians must renew their passion for advancing God’s kingdom.  <br /><br />

                        The burden of FSM concerning LOOK 2026 is to see God strengthen His mission workforce to be resilient in delivering 
                        the divine mandate of mobilising and equipping Christian students and youths for missions.. 

                      </p>
                      
                      <p style={{ textAlign: "left" }}>

                        <strong><b style={{ color: "#6d6c67"}}> This Conference is an opportunity for: </b> </strong>
                        <ul>
                          <li><strong> Christian Students </strong></li>
                          <li><strong>Mission-minded Christian Professionals</strong></li>
                          <li><strong> Missionaries</strong></li>
                          <li><strong> Mission agencies and related projects</strong></li>


                        </ul>

                      </p>
                      <hr/>
                      <p style={{ textAlign: "left" }}>

                      
                        <strong> <b style={{ color: "#6d6c67"}}>Conference Dates: </b></strong>
                        <ul>

                          <li>Family and Friends Session: 26 & 27 May, 2026 (virtual)</li>
                          <li>Pre-Conference Seminars: June - July, 2026 (Virtual)</li>
                          <li>Main Conference: 19 - 22 August, 2026</li>
                        </ul>

                        <strong> <b style={{ color: "#6d6c67"}}>Main Conference Location: </b></strong>
                        <ul> 
                        <li> Province Coordinating Hall, Redemption City, Ogun State, Nigeria</li>
                        </ul>

                        </p>

                        <hr/>

                        <p style={{ textAlign: "justify" }}>

                       
                       <strong> <b style={{ color: "#6d6c67"}}> Accommodation & Feeding (Main Conference - Physical Attendance): </b></strong><br/>
                        Dormitory accommodation and meals shall be provided free of charge as God provides. <br/>
                        
                        However, the following optional modes of accommodation shall be at individuals’ expense, on a booking-ahead basis: [Chalet - 10,000 Naira/night x 3 = 30,000; Executive Suite - 14,000 Naira/night x 3 =42,000]. Deadline for paid accommodation is July 31st, 2026. Send Proof of Payment to Bro. Shola +234 912 490 9429 via WhatsApp.

                        </p>

                          
                        <p style={{ textAlign: "left" }}>

                        <hr/>


                        <strong> <b style={{ color: "#6d6c67"}}>Support LOOK 2026: </b></strong> <br/>

                        While registration and event participation are free, participants are expected to support the Conference, 
                        financially, materially, technically, etc. 
                        The estimated cost to host at least 500 participants at LOOK 2026 is approximately <b><strong style={{ color: "#6d6c67"}}> NGN 21.5m, 
                        covering accommodation, feeding, and other logistics (N43,000 per participant). </strong> </b>
                        Your contribution enables us to continue mobilising and equipping Christian students for mission. <br/><br/>

                
                  
                        </p>

                        <hr/>

                        <p  style={{ textAlign: "left" }}>
                       
                        <strong> <b style={{ color: "#6d6c67"}}>  Registration Details: </b> </strong><br/>
                          Please fill out the form below to register for LOOK 2026.

                      </p>
                      <hr />
                      <div className="row">
                        <div className="form-group col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email Address"
                            name="email"
                            onChange={handleChange}
                            required
                          />
                          {returnMessage.email ? (
                            <small className="text-danger">
                              Application with this email already exists
                            </small>
                          ) : null}
                        </div>

                        <div className="form-group col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            name="name"
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="form-group col-md-12">
                          <CountryDropdown
                            defaultOptionLabel="Country Of Residence"
                            className="form-control"
                            name="country_of_residence"
                            value={country}
                            required
                            onChange={(val) => selectCountry(val)}
                          />
                        </div>

                        <div className="form-group col-md-12">
                          <RegionDropdown
                            blankOptionLabel="No country selected"
                            defaultOptionLabel="State/Region Of Residence"
                            disableWhenEmpty={true}
                            className="form-control"
                            country={country}
                            value={region}
                            onChange={(val) => selectRegion(val)}
                            required
                            name="state_region"
                          />
                        </div>

                        <div className="form-group col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="City Of Residense"
                            name="city_of_residence"
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-md-12">
                          {/* <br />
                      <p> Preferably WhatsApp Number</p> */}
                          <PhoneInput
                            international
                            required
                            name="phone_number"
                            defaultCountry="NG"
                            className="form-control"
                            countryCallingCodeEditable={false}
                            placeholder="Phone Number (Preferably Whatsapp)"
                            value={phoneNumber}
                            onChange={selectPhoneNumber}
                          />
                          {isPhoneValid ? null : (
                            <small className="text-danger">
                              Invalid Phone Number
                            </small>
                          )}

                          {returnMessage.phone_number ? (
                            <small className="text-danger">
                              Application with this Phone Number already exists
                            </small>
                          ) : null}
                        </div>

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="age_group"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Age Group </option>
                            <option value="Below 13">Below 13</option>
                            <option value="13-20">13-20</option>
                            <option value="21-30"> 21-30 </option>
                            <option value="31-40"> 31-40 </option>
                            <option value="41-50"> 41-50 </option>
                            <option value="51-60"> 51-60 </option>
                            <option value="Above 60"> Above 60 </option>
                          </select>
                        </div>

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="gender"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Gender </option>
                            <option value="Male">Male</option>
                            <option value="Female"> Female </option>
                          </select>
                        </div>

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="attendance_mode"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Attendance Mode </option>
                            <option value="Physical">Physical</option>
                            <option value="Virtual"> Virtual</option>
                            <option value="Satellite Center"> Satellite Center</option>
                          </select>
                        </div>

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="member"
                            onChange={handleChange}
                            required
                          >
                            <option value="">Are you A Member of FSM ? </option>
                            <option value="Yes">Yes</option>
                            <option value="No"> No </option>
                          </select>
                        </div>

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="category"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Student/Professional </option>
                            <option value="Professional">
                              Professional (Non-Student)
                            </option>
                            <option value="Student (Undergraduate)">
                              Student (Undergraduate)
                            </option>
                            <option value="Student (Postgraduate)">
                              Student (Postgraduate)
                            </option>
                            <option value="Student (Secondary)">
                              Student (Secondary)
                            </option>
                            <option value="Student (Primary)">
                              Student (Primary)
                            </option>
                          </select>
                        </div>

                        {category === "Professional" && (
                          <div className="col-md-12 ">
                            <div className="row">
                              <div className="col-md-12">
                                <hr />

                                <p>Professional (Non-Student)</p>
                              </div>

                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Occupation"
                                  name="occupation"
                                  onChange={handleChange}
                                  required
                                />
                              </div>

                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Work Place"
                                  name="work_place"
                                  required
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Church Affiliation"
                                  required
                                  name="church_affiliation"
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Student (Secondary)" || category === "Student (Primary)") && (
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-12">
                                <hr />

                                <p>Student</p>
                              </div>

                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Institution/School Name"
                                  name="institution"
                                  required
                                  onChange={handleChange}
                                />
                              </div>

                          {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Professional") && (
                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Course Of Study"
                                  name="course_of_study"
                                  required
                                  onChange={handleChange}
                                />
                              </div>)}

                              <div className="form-group col-md-12">
                                {renderLevelOptions()}
                              </div>

                              {/* <div className="form-group col-md-12">
                                <select
                                  className="form-control"
                                  name="year_level_part"
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Year/Level/Part</option>
                                  <option value="100 level"> 100 level</option>
                                  <option value="200 level"> 200 level</option>
                                  <option value="300 level"> 300 level</option>
                                  <option value="400 level"> 400 level</option>
                                  <option value="500 level"> 500 level</option>
                                  <option value="600 level"> 600 level</option>
                                </select>
                              </div> */}

                              {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)") && (<div className="form-group col-md-12">
                                <select
                                  className="form-control"
                                  name="final_year"
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">
                                    Are you a final year student?
                                  </option>
                                  <option value="Yes"> Yes</option>
                                  <option value="No"> No</option>
                                </select>
                              </div>)
                              }

                              {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Professional") && (
                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Fellowship Affiliation"
                                  required
                                  name="fellowship_affiliation"
                                  onChange={handleChange}
                                />
                              </div>)
                              }
                            </div>
                          </div>
                        )}

                        {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Professional") && (

                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="volunteering"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Volunteering </option>
                            <option value="Media">
                              Media
                            </option>
                            <option value="Jehoshaphat Music">
                              Jehoshaphat Music
                            </option>
                            <option value="Welfare">
                              Welfare
                            </option>
                            <option value="Registration">
                              Registration
                            </option>
                            <option value="Ushering">
                              Ushering
                            </option>
                            <option value="Children's department">
                              Children's department
                            </option>
                             <option value="None">
                              None
                            </option>
                          </select>
                        </div>)}

                        {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Professional") && (
                      
                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="accommodation"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> Accommodation </option>
                            <option value="Dormitory (free)">
                              Dormitory (free)
                            </option>
                            <option value="Executive(N14,000)">
                              Executive(N14,000)
                            </option>
                            <option value="Chalet (N10,000)">
                              Chalet (N10,000)
                            </option>

                             <option value="None">
                              None - Virtual Attendance
                            </option>

                            <option value="None">
                               Not Applicable
                            </option>
                          </select>
                        </div> )}

                      {(category === "Student (Undergraduate)" || category === "Student (Postgraduate)" || category === "Professional") && (
                        <div className="form-group col-md-12 ">
                          <select
                            className="form-control"
                            name="support_amount"
                            onChange={handleChange}
                            required
                          >
                            <option value=""> How much do you want to support with?  </option>
                            <option value="Below 50,000">
                              Below 50,000
                            </option>
                            <option value="50,000 - N100,000">
                              50,000 - N100,000
                            </option>
                            <option value="N100,000 - N500,000">
                              N100,000 - N500,000
                            </option>

                             <option value="N500,000 - N1,000,000">
                              N500,000 - N1,000,000
                            </option>

                             <option value="Above 1,000,000">
                              Above 1,000,000
                            </option>
                            <option value="None">
                              None
                            </option>

                        
                          </select>
    <p >
      <hr/>
                    Kindly send your support to: <br/>
                    Guarantee Trust Bank <br/>
                    Foundation for Student Mission <br/>
                    0164499277 <br/>
                    Thank you for your partnership! Stay Blessed!
                    <hr/>
  </p>
             

                        </div>)}

                        

                      
                      
                       
                        <div className="col-md-12 text-center">
                          {submitLoading ? (
                            <Loader
                              type="TailSpin"
                              color="#FF0000"
                              height={50}
                              width={50}
                            />
                          ) : (
                            <button
                              type="submit"
                              className="btn_hover success"
                              disabled={submitLoading}
                            >
                              Submit
                            </button>
                          )}
                        </div>
                        
                        <div className="single-element-widget">
                          <br/>
                     
                  
                  <hr/>

                          <p>
                            <strong> <b style={{ color: "#6d6c67"}}> Mobilizing and Equipping Christian Students for Mission </b></strong>
                            <br/>
                            Further information, please contact (Tel/WhatsApp) +2348037451485, 08137887362
                          </p>

                        </div>

                       
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
